import React from 'react';

import classNames from 'classnames';

export default function InvoicePaymentStatus({ status }) {
  const isFinished = status === 'applied' || status === 'paid';

  return (
    <div
      className={classNames(
        'text-sm font-semibold text-white px-3 rounded-full capitalize flex items-center justify-center',
        {
          'bg-amber-500': !isFinished,
          'bg-emerald-500': isFinished,
        }
      )}
    >
      {status}
    </div>
  );
}
